/**
 * Checks whether a drag-and-drop move is allowed based on linked document boundaries.
 *
 * Rules:
 * - Unlinked sections (no nextgenDocumentId) can be moved anywhere.
 * - Linked sections can only be moved within their contiguous group
 *   (consecutive sections sharing the same nextgenDocumentId).
 *
 * @param {Array} sections - Current flat sections array
 * @param {Object} sourceRow - TanStack row object for the dragged section (has .original)
 * @param {Object} targetRow - TanStack row object for the drop target (has .original)
 * @returns {boolean} true if the drop is allowed
 */
export function isDropAllowedForLinkedDocument(sections, sourceRow, targetRow) {
  const sourceDocId = sourceRow.original.nextgenDocumentId;
  if (!sourceDocId) {
    return true;
  }

  const sourceIndex = sections.findIndex((s) => s.id === sourceRow.original.id);
  if (sourceIndex === -1) {
    return true;
  }

  let groupStart = sourceIndex;
  let groupEnd = sourceIndex;

  while (
    groupStart > 0 &&
    sections[groupStart - 1].nextgenDocumentId === sourceDocId
  ) {
    groupStart--;
  }

  while (
    groupEnd < sections.length - 1 &&
    sections[groupEnd + 1].nextgenDocumentId === sourceDocId
  ) {
    groupEnd++;
  }

  const targetIndex = sections.findIndex((s) => s.id === targetRow.original.id);
  return targetIndex >= groupStart && targetIndex <= groupEnd;
}
